import React from 'react';

import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';

function DeleteConfirmDialog(props) {
  const actions = [
    <FlatButton
      primary={true}
      onClick={props.onRequestCancel}
      label="No" />,
    <FlatButton
      primary={true}
      onClick={props.onRequestDelete}
      label="Yes" />
  ];

  return (
    <Dialog
      open={true}
      actions={actions}
      title={props.title}>
      
      {props.message}
    
    </Dialog>
  );
}

export default DeleteConfirmDialog;


// WEBPACK FOOTER //
// ./src/components/DeleteConfirmDialog.js